import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import Audioknigi from '@/components/screens/audioknigi/Audioknigi';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IBooksPage } from '@/interfaces/booksPage.interface';

const AudioBooksPageDynamic: NextPage<IBooksPage> = ({ books }) => {
  useRedirectToFirstPage('/audioknigi/');

  return <Audioknigi books={books} sortingName="сначала новые" />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}satellite/books?book_type=audio_book&page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}&sort_field=created_at&sort_reversed=true`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default AudioBooksPageDynamic;
